// extracted by mini-css-extract-plugin
export var contentWrapper = "ListItem-module--contentWrapper--3kb9r";
export var imgWrapper = "ListItem-module--imgWrapper--iUekz";
export var itemWrapper = "ListItem-module--itemWrapper--hp1FC";
export var notMainImg = "ListItem-module--notMainImg--bF3Uh";
export var projectTitle = "ListItem-module--projectTitle--Fhh-C";